export function children( node, selector = null ) {
	let children = Array.from( node.children );

	if ( selector ) {
		children = children.filter( child => child.matches( selector ) );
	}

	return children;
}

export function focusable( node ) {
	const focusableNode = node.querySelector( [
		'a[href]',
		'[contenteditable]',
		'input:not([disabled])',
		'select:not([disabled])',
		'button:not([disabled])',
		'textarea:not([disabled])',
		'[tabIndex]:not([tabIndex="-1"])',
	].join(', ') );

	if ( focusableNode ) {
		focusableNode.focus();
	}

	return focusableNode;
}
